import { createSlice } from '@reduxjs/toolkit';
import { generatePaymentLink, checkPaymentStatus } from '../services/operations/paymentAPI';

const initialState = {
  loading: false,
  error: null,
  paymentUrl: null,
  paymentId: null,
  merchantOrderId: null,
  paymentStatus: null,
  isPaymentComplete: false,
  timestamp: null
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    resetPayment: () => initialState,
    setPaymentComplete: (state, action) => {
      state.isPaymentComplete = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Generate Payment Link
      .addCase(generatePaymentLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generatePaymentLink.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentUrl = action.payload.payment_url;
        state.merchantOrderId = action.payload.merchant_order_id; 
        state.paymentId = action.payload.payment_id;
      })
      .addCase(generatePaymentLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to generate payment link';
      })
      
      // Check Payment Status
      .addCase(checkPaymentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkPaymentStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentStatus = action.payload.status;
        state.timestamp = action.payload.timestamp;
        // Check if payment is completed based on the status from the API
        state.isPaymentComplete = action.payload.status === 'completed';
      })
      .addCase(checkPaymentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to check payment status';
      });
  }
});

export const { resetPayment, setPaymentComplete } = paymentSlice.actions;
export default paymentSlice.reducer;
